import { Injectable } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { PayrollAPIService } from 'app/api/payroll.api.service';
import { AppState } from 'app/reducers';
import { parseErrorMessage } from 'app/utils/callstate';
import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap } from 'rxjs/operators';
import { PayrollActions } from '../actions';
import * as _ from 'lodash';

@Injectable()
export class PayrollEffects {
  loadPayroll$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PayrollActions.payrollRequested),
      switchMap(({ query: { companyId, key, filter } }) =>
        this.payrollApiService.Payroll(companyId, key, filter).pipe(
          map((entries) => PayrollActions.payrollLoaded({ entries })),
          catchError((error) =>
            of(
                PayrollActions.payrollCancelled({
                  errorMessage: parseErrorMessage(error),
                })
              // PayrollActions.payrollLoaded({ entries: FAKE_DATA })
            )
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<AppState>,
    private payrollApiService: PayrollAPIService
  ) {}
}
